// FriendChip — a selectable friend pill used in every "pick friends" flow
// (new chat, group add, challenge invite, shared reminder…). Shows the
// friend's photo next to the name so people with the same name are
// distinguishable, and tapping the photo opens a profile preview.
// v29 §8 — replaces the e-mail that used to be shown for disambiguation.
import { Icon } from "../../icons";
import { Avatar } from "./Avatar";
import { Chk } from "./misc";
import { useProfileModal } from "./ProfileModalContext";

// Small hint shown above a friend picker — tells the user the photo is tappable.
export function FriendPickerHint({ style }) {
  return (
    <div style={{ fontSize: 11, fontWeight: 500, color: "var(--neutral-text-muted)", margin: "0 2px 8px", display: "inline-flex", alignItems: "center", gap: 5, ...style }}>
      <Icon name="avatar" size={13} color="var(--neutral-text-muted)" /> Ťukni na fotku a zobrazí sa náhľad profilu
    </div>
  );
}

export function FriendChip({ friend, selected, onToggle, chipStyle, chipOnStyle }) {
  const { open: openPublicProfile } = useProfileModal();
  return (
    <button type="button" onClick={() => onToggle(friend.friend_id)} className="chip"
      style={{ display: "inline-flex", alignItems: "center", gap: 6, ...chipStyle, ...(selected ? chipOnStyle : {}) }}>
      {selected ? <Chk /> : null}
      <Avatar user={friend} size={18} onClick={(e) => { e.stopPropagation(); openPublicProfile(friend.friend_id); }} />
      <span>{friend.name}</span>
    </button>
  );
}
